import { useEffect, useState } from "react"
import bucketService from "../Services/bucketService"
import toast from "react-hot-toast"

const CloudAssert = () => {
  const [loadAssert, setLoadAsserts] = useState<any>({
    states: [],
    lgas: [],
    subjects: [],
    waec: [],
    country: []
  })

  const loadStates = async () => {
    try {
      const response = await bucketService.stateService()
      if (response !== undefined) {
        setLoadAsserts((prevState: any) => ({ ...prevState, states: response.data }))
      }
    } catch (error) {
      toast.error('Currently unable to load assert, contact support')
    }
  }
  const loadlgas = async () => {
    try {
      const response = await bucketService.lgaService()
      if (response !== undefined) {
        setLoadAsserts((prevState: any) => ({ ...prevState, lgas: response.data }))
      }
    } catch (error) {
      toast.error('Currently unable to load assert, contact support')
    }
  }
  const loadSubject = async () => {
    try {
      const response = await bucketService.subjectService()
      if (response !== undefined) {
        setLoadAsserts((prevState: any) => ({ ...prevState, subjects: response.data }))
      }
    } catch (error) {
      toast.error('Currently unable to load assert, contact support')
    }
  }
  const loadExamTypes = async () => {
    try {
      const response = await bucketService.waecService()
      if (response !== undefined) {
        setLoadAsserts((prevState: any) => ({ ...prevState, waec: response.data }))
      }
    } catch (error) {
      toast.error('Currently unable to load assert, contact support')
    }
  }
  //   const loadCountry = async () => {
  //     try {
  //       const response = await bucketService.stateService()
  //       if (response !== undefined) {
  //         setLoadAsserts((prevState: any) => ({ ...prevState, states: response.data }))
  //       }
  //     } catch (error) {
  //       toast.error('Currently unable to load assert, contact support')
  //     }
  //   }

  useEffect(() => {
    loadStates()
    loadExamTypes()
    loadSubject()
    loadlgas()
  }, [])

  return { loadAssert }
}

export default CloudAssert
